<template>
  <div class="upload_wrapper">
    <el-upload
      class="avatar-uploader"
      :data={folderName}
      :action="uploadAddr + 'upload/upload'"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload">
      <div v-if="fileUrl" class="fileName">
        <a :src="getfile">{{fileName}}</a>
      </div>
      <div v-else class="choose">
        <i></i>
        <div class="text">{{text}}</div>
      </div>
    </el-upload>
  </div>

</template>
<script>
  // import {mapGetters} from 'vuex'

  export default {
    props: {
      folderName: {},
      appendUrl: {
        default: ''
      },
      text: {
        default: ''
      },
      appendName: {
        default: ''
      },
      width: {
        default: ''
      },
      height: {
        default: 120
      }
    },
    data () {
      return {
        picAddr: '',
        fileUrl: '',
        fileName: ''
      }
    },
    watch: {
      appendUrl (val1,val2) {
        if (val1) {
          this.fileUrl = this.uploadAddr+val1
        }
      },
      appendName (val1,val2) {
        if (val1) {
          console.log(val1)
          this.fileName = val1
        }
      }
    },
    created () {
    },
    activated() {
      console.log(this.appendUrl)
      if (this.appendUrl) {
        this.fileUrl = this.uploadAddr+this.appendUrl
      } else {
        this.fileUrl = ''
      }
      this.fileName = this.appendName
    },
    methods: {
      handleAvatarSuccess (res, file) {
        this.fileUrl = file.response.file.url
        this.fileName = file.response.file.fileName
        this.$emit('changed', this.fileUrl.replace(this.uploadAddr, ''),this.fileName)
      },
      beforeAvatarUpload (file) {
        const isLt10M = file.size / 1024 / 1024 < 10
        if (!isLt10M) {
          // this.$message.error('上传图片大小不能超过 2MB!')
        }
        return isLt10M
      }
    },
    computed: {
      headers () {
        return {
          Authorization: 'Bearer ' + window.localStorage.getItem('token')
        }
      },
      getfile () {
        return this.uploadAddr + this.fileUrl.replace(this.uploadAddr, '')
      },
      uploadAddr() {
        return this.$store.getters.uploadAddr
      }
      // ...mapGetters(['picAddr'])
    }

  }
</script>
<style lang="scss" scoped>
  .upload_wrapper {
    .fileName {
      width: 100%;
      /*height: 150px;*/
    }

    .pic img {
      max-height: 160px;
      max-width: 100%;
    }

    .choose {
      display: flex;
      flex-direction: column;
      align-items: center;
      i {
        display: block;
        width: 42px;
        height: 43px;
        background-size: 42px 43px;
        background-image: url("../../assets/image/icon_plus.png");
      }
      .text {
        padding-top: 5px;
      }
    }
  }
</style>

